import { TimelineParty } from '../slices/marketplace/timeline/models/enums/timeline-party.enum';
import { MarketplaceOpportunity } from '../slices/marketplace/opportunity/models/opportunity';

/**
 * Mirrors the backend access rule for buyer-party engagement endpoints
 * (EngagementMeetings, activity logs): a buyer may only call them when they
 * are an ACTIVE buyer on the engagement. Non-buyer parties (seller, admin,
 * broker) are validated server-side by other rules and are allowed through.
 *
 * For buyers, access must be positively proven from the loaded opportunity —
 * an unknown or mismatched selection means "no access" rather than "assume
 * access", so we never fire requests that are guaranteed to 403.
 */
export const isBuyerPartOfEngagement = (
    party: TimelineParty,
    selectedOpportunity: MarketplaceOpportunity | null | undefined,
    engagementId: number
): boolean => {
    if (party !== TimelineParty.Buyer) {
        return true;
    }

    if (selectedOpportunity?.opportunityId === engagementId) {
        return selectedOpportunity.buyer?.isActive === true;
    }

    return false;
};
